import React from "react";
import IntlMessages from "../../../../util/IntlMessages";
import { isShoperApp } from "../../../../util/appType";
import './ChatLimitWarning.less';

const ChatLimitWarning = ({isArchive, conversationsLength}) => {
    return <>
        {!isArchive && conversationsLength >= 1000 && (
            <div className="chat-limit">
                <IntlMessages id={isShoperApp ? "conversations.limit.shoper_connect" : "conversations.limit"}/>
            </div>
        )}
    </>;
};

export default ChatLimitWarning;
